export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-01.e99c37f7.jpg";